var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSampleDocumentLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 208,
    viewBox: "0 0 150 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_777_14020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46885 203.696C4.49109 203.291 3.70898 202.509 3.30352 201.531L3.76539 201.34C3.59454 200.928 3.5 200.475 3.5 200V195.958H3V187.875H3.5V179.792H3V171.708H3.5V163.625H3V155.542H3.5V147.458H3V139.375H3.5V131.292H3V123.208H3.5V115.125H3V107.042H3.5V98.9583H3V90.875H3.5V82.7917H3V74.7083H3.5V66.625H3V58.5417H3.5V50.4583H3V42.375H3.5V34.2917H3V26.2083H3.5V18.125H3V10.0417H3.5V6C3.5 5.52451 3.59454 5.07236 3.76539 4.66037L3.30352 4.46885C3.70898 3.49109 4.49109 2.70898 5.46885 2.30352L5.66038 2.76539C6.07236 2.59454 6.52451 2.5 7 2.5H11.016V2H19.048V2.5H27.08V2H35.112V2.5H43.144V2H51.1759V2.5H59.2079V2H67.2399V2.5H75.2719V2H83.3039V2.5H91.3359V2H99.3679V2.5H103.384C103.615 2.5 103.843 2.52281 104.066 2.56716L104.164 2.07676C104.679 2.17912 105.169 2.38191 105.605 2.6734L105.327 3.08922C105.517 3.21554 105.694 3.36089 105.858 3.52407L108.334 5.99806L108.687 5.64436L113.639 10.5923L113.286 10.946L118.238 15.894L118.592 15.5403L123.544 20.4883L123.19 20.842L125.666 23.316L128.142 25.7898L128.496 25.4361L133.448 30.3837L133.094 30.7374L138.046 35.685L138.399 35.3313L143.351 40.2789L142.998 40.6326L145.474 43.1065C145.637 43.2698 145.783 43.4476 145.91 43.6369L146.325 43.359C146.617 43.7959 146.82 44.2862 146.923 44.8016L146.433 44.8992C146.477 45.1225 146.5 45.3513 146.5 45.5824V49.4428H147V57.1637H146.5V64.8846H147V72.6055H146.5V80.3264H147V88.0472H146.5V95.7681H147V103.489H146.5V111.21H147V118.931H146.5V126.652H147V134.373H146.5V142.093H147V149.814H146.5V157.535H147V165.256H146.5V172.977H147V180.698H146.5V188.419H147V196.14H146.5V200C146.5 200.475 146.405 200.928 146.235 201.34L146.696 201.531C146.291 202.509 145.509 203.291 144.531 203.696L144.34 203.235C143.928 203.405 143.475 203.5 143 203.5H139.222V204H131.667V203.5H124.111V204H116.556V203.5H109V204H101.444V203.5H93.8889V204H86.3334V203.5H78.7778V204H71.2222V203.5H63.6667V204H56.1111V203.5H48.5556V204H41V203.5H33.4444V204H25.8889V203.5H18.3333V204H10.7778V203.5H7C6.52451 203.5 6.07236 203.405 5.66038 203.235L5.46885 203.696Z",
    fill: "url(#paint0_linear_777_14020)",
    stroke: "#1F6BEB",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 43.9245H106.004C105.471 43.9245 105.04 43.4979 105.04 42.9717V2L147 43.9245Z",
    fill: "url(#paint1_linear_777_14020)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 61.0754,
    width: 113.483,
    height: 8.57547,
    fill: "url(#paint2_linear_777_14020)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 35.3491,
    width: 40.053,
    height: 8.57547,
    fill: "url(#paint3_linear_777_14020)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 79.1792,
    width: 113.483,
    height: 8.57547,
    fill: "url(#paint4_linear_777_14020)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 97.283,
    width: 113.483,
    height: 8.57547,
    fill: "url(#paint5_linear_777_14020)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2583,
    y: 115.387,
    width: 41.9603,
    height: 8.57548,
    fill: "url(#paint6_linear_777_14020)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_777_14020",
    x: 0,
    y: 0,
    width: 150,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_777_14020"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_777_14020",
    result: "effect2_dropShadow_777_14020"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_777_14020",
    result: "effect3_dropShadow_777_14020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_777_14020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_777_14020",
    x1: 5.38411,
    y1: 6.28774,
    x2: 144.934,
    y2: 204.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214689,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_777_14020",
    x1: 107.424,
    y1: 42.0189,
    x2: 144.139,
    y2: 42.4961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_777_14020",
    x1: 18.2583,
    y1: 65.8396,
    x2: 138.894,
    y2: 65.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_777_14020",
    x1: 18.2583,
    y1: 40.1133,
    x2: 60.8356,
    y2: 40.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_777_14020",
    x1: 18.2583,
    y1: 83.9434,
    x2: 138.894,
    y2: 83.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_777_14020",
    x1: 18.2583,
    y1: 102.047,
    x2: 138.894,
    y2: 102.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_777_14020",
    x1: 18.2583,
    y1: 120.151,
    x2: 62.8631,
    y2: 120.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleDocumentLoadingIcon);
export default __webpack_public_path__ + "static/media/SampleDocumentLoadingIcon.6a2fc9d2.svg";
export { ForwardRef as ReactComponent };